<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout
          class="table--first-row"
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              class="table__btn--blue"
              v-show="selectedRow"
              @click="openWatermeterCard"
            >note</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="openWatermeterCard"
            >OTWÓRZ KARTĘ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
              class="table__btn--blue"
            >cloud_download</v-icon>
            <p
              class="caption"
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
            >POBIERZ REJESTR</p>
            <v-icon
              class="table__btn--padding"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >PRZYBLIŻ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      class="ag-theme-balham"
      :gridOptions="gridOptions"
      style="height: 90%"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    filter: "",
    numberAll: '0', //hint z textfielda wymaga, by wartość była typu string
    numberFiltered: '0', //hint z textfielda wymaga, by wartość była typu string
    selectedRow: undefined,
    statusFilter: '',
    tableTitle: "watermetersTable",
    watermeters: [],
    features: []
  }),
  components: {
    AgGridVue,
    ExportTableData,
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onSelectionChanged: this.onSelectionChanged,
        onFilterChanged: this.filterColumn,
        rowSelection: "single",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          lessThan: "Mniejsza niż",
          greaterThan: "Większa niż",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    }
  },
  beforeMount() {
    const formatDate = function (date, time) {
      if(date.value) {
        let options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }
        if(time) {
          options.hour = "2-digit"
          options.minute = "2-digit"
        }
        return new Date(date.value).toLocaleString("pl-PL", options);
      } else {
        return null
      }
    }
    //Funkcja porównująca daty (splitujemy string, tworzymy obiekt daty, która leci do porównania)
    const compareDate = function (filterLocalDateAtMidnight, cellValue) {
      if(!cellValue) return 0
      let date = new Date(cellValue);
      let dateString;
      let timeString;
      if (cellValue.includes('T')) {
        [dateString, timeString] = cellValue.split('T');
      } else {
        [dateString, timeString] = cellValue.split(' ');
      }
      var dateStringParts = dateString.split("-");
      // let timeStringParts = timeString.split(':')
      var day = Number(dateStringParts[2]);
      var month = Number(dateStringParts[1]) - 1;
      var year = Number(dateStringParts[0]);
      // TODO spróbować naprawić godziny i minuty
      // let hours = Number(timeStringParts[0])
      // let minutes = Number(timeStringParts[1])
      var cellDate = new Date(year, month, day);
      if(cellDate < filterLocalDateAtMidnight) {
        return -1;
      } else if(cellDate > filterLocalDateAtMidnight) {
        return 1;
      } else {
        return 0;
      }
    }
    this.columnDefs = [
      {headerName: "ID", field: "id", sort: "asc", width: 100},
      {headerName: "Numer punktu rozbioru wody", field: "properties.parent_partition"},
      {
        headerName: "Identyfikator w systemie billingowym", 
        field: "properties.billing_id",
        comparator: function (number1, number2) {
          if (number1 === null && number2 === null) {
            return 0;
          }
          if(isNaN(number1)){ return -1}
          if(isNaN(number2)){ return 1}
          if (number1 === null) {
            return -1;
          }
          if (number2 === null) {
            return 1;
          }
          return number1 - number2;
        }
      },
      {headerName: "Numer kartoteki wodomierza", field: "properties.nrkartotekiwodomierz"},
      {
        headerName: "Numer wodomierza", 
        field: "properties.nrwodomierz",
        comparator: (_as, bs) => {
          if (_as && bs) {
            var a, b, a1, b1, i= 0, n, L,
            rx=/(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
            if(_as=== bs) return 0;
            a= _as.toLowerCase().match(rx);
            b= bs.toLowerCase().match(rx);
            L= a.length;
            while(i<L){
                if(!b[i]) return 1;
                a1= a[i],
                b1= b[i++];
                if(a1!== b1){
                    n= a1-b1;
                    if(!isNaN(n)) return n;
                    return a1>b1? 1:-1;
                }
            }
            return b[i]? -1:0;
          }
        } 
      },
      {
        headerName: "Grupa",
        field: "properties.grupa"
      },
      {
        headerName: "Data montażu",
        field: "properties.datamontazwodomierz"
      },
      {
        headerName: "Miejscowość",
        field: "properties.miejscowosc"
      },
      {
        headerName: "Ulica",
        field: "properties.ulica"
      },
      {
        headerName: "Nr domu",
        field: "properties.nrdomu"
      },
      {
        headerName: "Nr lokalu",
        field: "properties.nrlokalu"
      },
      {
        headerName: "Właściciel",
        field: "properties.wlasciciel",
        valueFormatter: params => {
          if (params.data.properties.wlasciciel == 'Z') {
            return "Zakład"
          } else {
            return "Klient"
          }
        }
      },
      {
        headerName: "Własność przyłącza",
        field: "properties.wlasnoscprzylacza"
      },
      {
        headerName: "Upływ cech legalizacji", field: "properties.datalegalnosciwodomierz", cellRenderer: date => formatDate(date, false),
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => compareDate(filterLocalDateAtMidnight, cellValue),
          browserDatePicker: true
        },
      },
      {
        headerName: "Odczyt",
        field: "properties.odczyt"
      },
      {
        headerName: "Średnica",
        field: "properties.srednicawodomierz"
      },
      {
        headerName: "Status",
        field: "properties.status"
      },
      {headerName: "Geometria", field: "geometry", hide: true}
    ];
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    loadData() {
      const self = this;
      let payload = {
        layername: 'watermeters',
        srid: 2180,
        with_geometry: true
      }
      this.$store.dispatch('getFeatures', payload).then(r => {
        this.watermeters = r.features;
        this.numberAll = r.features.length;
        this.numberFiltered = this.numberAll;
        this.gridOptions.api.setRowData(r.features);
      })
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
      // this.$root.$emit('removeMapLayer');
    },
    openWatermeterCard() {
      let payload = {
        object_id: this.selectedRow.id,
        object_type: 'watermeters',
        limit: 5,
        events_count: true
      };
      let singleWatermeter = this.watermeters.filter(el => el.id == this.selectedRow.id);
      this.$root.$emit('loadWatermeterCard', singleWatermeter);
      this.$store.dispatch("getFeatureEvents", payload).then(() => {
        this.show("watermeterCard");
      })

    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    zoomToGeometry() {
      this.$root.$emit("zoomToFeature", this.selectedRow, {
        srid: this.srid
      });
    }

  },
  mounted() {
    this.$root.$on("edited_prw", this.loadData);
    this.$root.$on("loadWatermeters", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/WatermetersTable.vue